import React, { Fragment, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Card, TextField } from "@material-ui/core";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

import SpinnerSmall from "../../../layout/SpinnerSmall";

import ConfirmationModal from "./ConfirmationModal";

const FunctionAppeal = ({
  state,
  setState,
  dispute,
  order,
  selectedFunction,
  handleClose,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { appealDispute, loading } = disputeContext;

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmDisplay, setConfirmDisplay] = useState("");

  const useStyles = makeStyles((theme) => ({
    modalBody: {
      padding: theme.spacing(2),
    },
    inputWidth: {
      width: "100%",
    },
  }));

  const classes = useStyles();

  const [trackingNumber, setTrackingNumber] = useState([]);
  useEffect(() => {
    if (order) {
      const tempArray = [];
      for (let x in order) {
        for (let y in order[x].fulfillments) {
          tempArray.push(order[x].fulfillments[y].tracking_number);
        }
      }
      setTrackingNumber(tempArray);
    } else {
      setTrackingNumber([]);
    }
  }, [order]);

  //Filter Input Value
  const onInputChange = (e) => {
    e.preventDefault();
    e.persist();

    if (e.target.id === "tracking_number") {
      const value = e.target.value.trim();
      // let errors = state.appeal.errors;
      let appeal = state.appeal;
      if (trackingNumber.length === 0) {
        appeal.tracking_number = value;
        setState((state) => ({
          ...state,
          appeal: appeal,
        }));
      }
    }

    if (e.target.id === "note_value") {
      const value = e.target.value;
      let errors = state.appeal.errors;
      let appeal = state.appeal;
      if (value.length > 2000) {
        errors.note_value = "Maximum 2000 characters";
      } else {
        errors.note_value = "";
      }
      appeal.note_value = value;
      setState((state) => ({
        ...state,
        appeal: appeal,
      }));
    }
  };

  const [isLoading, setIsLoading] = useState();
  const [okClick, setOkCLick] = useState();

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (okClick === "appeal") {
      var tracking_no = [];
      if (trackingNumber.length > 0) {
        tracking_no = trackingNumber;
      } else {
        const tracking_number_splited = state.appeal.tracking_number.split(",");
        for (let x in tracking_number_splited) {
          if (tracking_number_splited[x]) {
            tracking_no.push(tracking_number_splited[x]);
          }
        }
      }
      appealDispute(
        dispute.dispute_id,
        state.appeal.evidence_type,
        state.appeal.carrier_name,
        tracking_no,
        state.appeal.note_value
      );
      setReturnedMsg("");
      setIsLoading(true);
      setOkCLick("");
    }
    //eslint-disable-next-line
  }, [okClick]);

  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
    setConfirmDisplay([
      {
        label: "Evidence Type",
        value: state.appeal.evidence_type,
      },
      {
        label: "Carrier Name",
        value: state.appeal.carrier_name,
      },
      {
        label: "Tracking Number",
        value: state.appeal.tracking_number,
      },
      {
        label: "Note",
        value: state.appeal.note_value,
      },
    ]);
  };

  return (
    <Fragment>
      {" "}
      {selectedFunction === "appeal" ? (
        <Grid container direction="column" className={classes.modalBody}>
          <Card className={classes.modalBody}>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      id="evidence_type"
                      name="evidence_type"
                      size="small"
                      fullWidth
                      label="Evidence Type"
                      value={state.appeal.evidence_type}
                      disabled={loading === false ? false : true}
                    />{" "}
                  </Grid>{" "}
                  <Grid item xs={6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      id="carrier_name"
                      name="carrier_name"
                      size="small"
                      fullWidth
                      label="Carrier Name"
                      value={state.appeal.carrier_name}
                      disabled={loading === false ? false : true}
                    />{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="tracking_number"
                  name="tracking_number"
                  size="small"
                  fullWidth
                  label="Tracking Number"
                  value={
                    trackingNumber.length > 0
                      ? trackingNumber
                      : state.appeal.tracking_number
                  }
                  onChange={onInputChange}
                  helperText={
                    "For multiple Tracking Number use comma (,) e.g (TrackingNumber1,TrackingNumber2,...)"
                  }
                  disabled={loading === false ? false : true}
                  // error={
                  //   state.appeal.errors.note_value ? true : false
                  // }
                />{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="note_value"
                  name="note_value"
                  size="small"
                  fullWidth
                  label="Note"
                  placeholder="Leave a note..."
                  multiline
                  rows={10}
                  maxRows={20}
                  value={state.appeal.note_value}
                  onInput={onInputChange}
                  helperText={state.appeal.errors.note_value}
                  error={state.appeal.errors.note_value ? true : false}
                  disabled={loading === false ? false : true}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onSubmit}
                    disabled={
                      state.appeal.note_value.length > 0 &&
                      state.appeal.note_value.length <= 2000 &&
                      loading === false &&
                      (trackingNumber.length > 0
                        ? trackingNumber
                        : state.appeal.tracking_number)
                        ? false
                        : true
                    }
                  >
                    {loading ? (
                      <div className="d-flex mx-auto my-auto">
                        <SpinnerSmall />
                      </div>
                    ) : (
                      <Fragment> {"Submit"} </Fragment>
                    )}{" "}
                  </Button>{" "}
                </Grid>{" "}
                <ConfirmationModal
                  confirmModal={confirmModal}
                  setConfirmModal={setConfirmModal}
                  confirmDisplay={confirmDisplay}
                  setConfirmDisplay={setConfirmDisplay}
                  setOkCLick={setOkCLick}
                  selectedFunction={selectedFunction}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>
      ) : null}{" "}
    </Fragment>
  );
};

export default FunctionAppeal;
